import React, { useState } from 'react'
import styles from './login.module.css'
import { login, sendLoginOtp } from '../../../action/auth';
import Loader from '../../Common/Loader/index'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';

const Index = () => {

    const [state, setState] = useState({
        email: { name: 'email', value: '', isRequired: true, error: '' },
        password: { name: 'password', value: '', type: 'password', isRequired: true, error: '' },
        otp: { name: 'otp', value: ['', '', '', '', '', ''], isRequired: false, error: '' },
        mode: { name: 'mode', value: 'password', isRequired: true, error: '' },
        ref_code: { name: 'ref_code', value: '', isRequired: false, error: '' },
        mobile: { name: 'mobile', value: '', isRequired: false, error: '' },

    });

    const history = useHistory()

    const [showLoader, setShowLoader] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };

    const handleOTPChange = (e, index) => {

        const { value } = e.target;

        if (value.match(/^[0-9]$/) || value === '') {
            const newValues = [...state.otp.value];
            newValues[index] = value;

            setState({
                ...state,
                otp: { ...state.otp, value: newValues },
            });

            if (value && index < newValues.length - 1) {
                document.getElementsByTagName('input')[index + 1].focus();
            }
        }
    };
    const handleOTPKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !state.otp.value[index] && index > 0) {
            document.getElementsByTagName('input')[index - 1].focus();
        }
    };
    const togglePasswordVisibility = () => {
        setState((prev) => ({
            ...prev,
            password: {
                ...prev.password,
                type: prev.password.type === 'password' ? 'text' : 'password',
            },
        }));
    };

    const handleSubmit = () => {
        let valid = true;
        const updatedState = { ...state };

        // Validate required fields and OTP
        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                valid = false;
                updatedState[key].error = `${state[key].name} is required`;
            } else {
                updatedState[key].error = '';
            }
        });

        // OTP validation
        if (state.mode.value === 'otp') {
            const otpValue = state.otp.value.join(''); // Join the OTP array into a single string
            if (otpValue.length !== 6 || !/^\d{6}$/.test(otpValue)) {
                valid = false;
                updatedState.otp.error = 'OTP must be a 6-digit number';
            } else {
                updatedState.otp.error = ''; // Clear error if OTP is valid
            }
        }

        setState(updatedState);

        if (valid) {
            setShowLoader(true)

            let payload = {};
            if (state.mode.value === 'password') {
                payload.email = state.email.value;
                payload.password = state.password.value;
                payload.mode = 'password'

            } else {
                payload.ref_code = state.ref_code.value;
                payload.otp = state.otp.value.join(''); // Combine OTP digits into a single string
            }

            login(payload)
                .then((res) => {
                    if (res.status) {
                        history.push(constant.component.dashboard.url);
                    } else {
                        toast.error(res.error);
                    }
                })
                .catch((error) => {
                    console.error("Error during login:", error);
                    toast.error("An error occurred during login. Please try again.");
                })
                .finally(() => {
                    setShowLoader(false);
                });

        }
    };

    const onSendLoginOtp = () => {
        let valid = true;
        const updatedState = { ...state };
        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value && key === 'email') {
                valid = false;
                updatedState[key].error = `${state[key].name} is required`;
            } else {
                updatedState[key].error = '';
            }
        });

        setState(updatedState);

        if (valid) {
            setShowLoader(true)
            sendLoginOtp({
                email: state.email.value,
            }).then(res => {
                setShowLoader(false)
                if (res.status) {
                    setState((prev) => ({
                        ...prev,
                        otp: {
                            ...prev.otp,
                            isRequired: true,
                        },
                        mode: {
                            ...prev.mode,
                            value: 'otp',
                        },
                        ref_code: {
                            ...prev.ref_code,
                            value: res.result.ref_code
                        },
                        mobile: {
                            ...prev.mobile,
                            value: res.result.mobile
                        },
                        password: {
                            ...prev.password,
                            isRequired: false,
                        }
                    }));
                }
                else {
                    toast.error(res.error)
                }
            })
        }
    }

    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <div className={`${styles['hero-bg']}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-7'>
                            <h5 className='my-4'><span className={`${styles['hero-title']}`}>Your dream job is just a click away.<img src='https://cdn.jobzseed.com/employer/images/homepage/ai-animation.svg' className='ps-2' /></span></h5>
                            <h1 className={`${styles['hero-heading']}`}>Explore <span className={`${styles['text-yellow']}`}>Endless Possibilities</span> with Jobs Across India</h1>
                            <p className={`${styles['hero-para']}`}>Stay ahead with the latest job openings across India by following industry trends and expert insights shared by top influencers on social media. Begin your career journey by exploring fresh opportunities and expanding your professional network with us. </p>
                            <div className='mt-3'>
                                <a href={constant.component.register.url} className={`${styles['login-btn']} btn`}>Register</a>
                                <a href={constant.component.OnlineSalesEnquiry.url} className={`${styles['inquire-btn']} btn`}>Enquire</a>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className={`${styles['contact-card']} card`}>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className="mb-3 position-relative">
                                                <h4 className={`${styles['post-title']}`}>Post a free Job</h4>
                                            </div>
                                            {state.mode.value === 'password' ? <div>
                                                <div className="mb-3 position-relative">

                                                    <input
                                                        type="email"
                                                        className={`${styles['form-ctrl']} form-control ${!state.email.value && state.email.error ? 'is-invalid' : ''}`}
                                                        placeholder="Email"
                                                        name={state.email.name}
                                                        value={state.email.value}
                                                        onChange={handleChange}
                                                        aria-label="Email Address"
                                                    />
                                                    {state.email.error && (
                                                        <small className="text-danger ps-2">
                                                            {state.email.error}
                                                        </small>
                                                    )}
                                                </div>
                                                <div className="mb-3 position-relative">

                                                    <input
                                                        type={state.password.type}
                                                        className={`${styles['form-ctrl']} form-control ${!state.password.value && state.password.error ? 'is-invalid' : ''}`}
                                                        placeholder="Password"
                                                        name={state.password.name}
                                                        value={state.password.value}
                                                        onChange={handleChange}
                                                        aria-label="Password"
                                                    />
                                                    <span
                                                        className={`${styles['password-icon']}`}
                                                        onClick={togglePasswordVisibility}
                                                        role="button"
                                                        aria-label="Toggle Password Visibility"
                                                    >
                                                        <i
                                                            className={`la ${state.password.type === 'password'
                                                                ? 'la-eye-slash'
                                                                : 'la-eye'
                                                                }`}
                                                        />
                                                    </span>
                                                    {state.password.error && (
                                                        <small className="text-danger ps-2">
                                                            {state.password.error}
                                                        </small>
                                                    )}
                                                </div>
                                                <button type="submit" className={`${styles['signin-btn']} btn w-100`}
                                                    onClick={() => {
                                                        handleSubmit()
                                                    }}
                                                >Sign in</button>
                                            </div> :
                                                <div className="d-flex flex-column align-items-center">
                                                    {/* OTP Input Boxes */}
                                                    <div className="text-center mb-2">
                                                        <p className={`${styles['form-text']}`}>
                                                            Enter the OTP sent to your email <strong>{state.email.value}</strong> or mobile <strong>******{state.mobile.value.slice(-4)}</strong>.
                                                        </p>

                                                    </div>
                                                    <div className="d-flex justify-content-center mb-3">

                                                        {state.otp.value.map((digit, index) => (
                                                            <input
                                                                key={index}
                                                                type="text"
                                                                className={`${styles['form-ctrl']} ${styles['otp-input']} form-control ${!digit && state.otp.error ? 'is-invalid' : ''} text-center`}
                                                                maxLength="1"
                                                                placeholder="-"
                                                                value={digit}
                                                                onChange={(e) => handleOTPChange(e, index)}
                                                                onKeyDown={(e) => handleOTPKeyDown(e, index)}
                                                                aria-label={`OTP Digit ${index + 1}`}

                                                            />
                                                        ))}
                                                    </div>

                                                    {/* Sign In Button */}
                                                    <button
                                                        type="button"
                                                        className={`${styles['signin-btn']} btn w-100`}
                                                        onClick={() => {
                                                            handleSubmit()
                                                        }}

                                                    >
                                                        Submit
                                                    </button>
                                                </div>


                                            }
                                            {state.mode.value === 'password' && <div className="mt-3 text-center">
                                                <a href="javascript:void(0);"
                                                    onClick={() => {
                                                        onSendLoginOtp()
                                                    }}
                                                    className={`${styles['form-link']}`}>Login With OTP</a>
                                            </div>}
                                            {state.mode.value === 'otp' && <div className="mt-3 text-center">
                                                <a href="javascript:void(0);"
                                                    onClick={() => {
                                                        setState((prev) => ({
                                                            ...prev,
                                                            password: {
                                                                ...prev.password,
                                                                isRequired: true,
                                                            },
                                                            otp: {
                                                                ...prev.otp,
                                                                isRequired: false,
                                                            },
                                                            mode: {
                                                                ...prev.mode,
                                                                value: 'password',
                                                            }
                                                        }));
                                                    }}
                                                    className={`${styles['form-link']}`}>Login With Password</a>
                                            </div>}

                                            <div className="mt-5 text-center">
                                                <p className={`${styles['form-text']}`}>Don't have an account? <Link to={constant.component.register.url} className={`${styles['form-link']}`}>Register Now</Link></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index